/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContent
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContent {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContent
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContent
     */
    contents?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContentFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContent {
    return JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContentFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
        'contents': !exists(json, 'contents') ? undefined : json['contents'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContentToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'contents': value.contents,
    };
}

